import React from "react";

import withStyles from "@mui/styles/withStyles";
import { colors } from "@zapalacorp/tokens";
import classnames from "classnames";

import { MarineEventsStatus } from "../../../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      padding: "8px 12px",
      height: "32px",
      borderRadius: "100px",
      whiteSpace: "nowrap",
      width: "fit-content",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Manrope",
      fontSize: "12px",
      fontWeight: 600,
      lineHeight: "16px",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const EventStatusBadge = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case MarineEventsStatus.CANCELLED:
      return renderBadge(colors.error50, colors.error600, value);
    default:
      return renderBadge("#eafaf9", "#38CFC4", value);
  }
};

export default EventStatusBadge;
